var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_5364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0992 9.07285L11.9737 7.94737L15.7369 3.1579H7.18426L5.60534 1.57898H17.3583C17.6889 1.57898 17.9288 1.72472 18.0779 2.01622C18.227 2.30771 18.2004 2.58841 17.998 2.85832L13.0992 9.07285ZM18.7409 19.923L12.1053 13.2874V16.4372C12.1053 16.7017 12.0162 16.923 11.8381 17.1012C11.6599 17.2793 11.4386 17.3684 11.1741 17.3684H9.87863C9.61412 17.3684 9.3928 17.2793 9.21466 17.1012C9.03652 16.923 8.94745 16.7017 8.94745 16.4372V10.1295L0.0770264 1.25911L1.18632 0.133636L19.8664 18.8137L18.7409 19.923Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_5364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOff);
export default __webpack_public_path__ + "static/media/filter-off.fe1762b4fd07a59b8b011bde1ebdfb34.svg";
export { ForwardRef as ReactComponent };